<template>
  <div id="zts260">
    <div id="z1">
      <div>ZTS260 </div>
      <label>一体式扫码终端</label>
      <img :src="require('@/assets/pic/zts260/bg1icon.png')" />
    </div>
    <div id="z2">
      <label>ZTS260是一款台式扫码支付终端，外观时尚，轻巧简洁。配备2.4寸彩屏液晶，支持交易二维码显示，供顾客主扫，支持语音播报功能。可选内置非接读卡器，可实现挥卡闪付收款。支持4G与WIFI双通讯方式。产品通过中国银联动态二维码生成设备测试、qPBOC认证，安全可靠。</label>
    </div>
    <div id="z3">
      <h3>硬解码，识别快，精度高</h3>
      <div>
        <img :src="require('@/assets/pic/zts260/bg2icon1.png')" />
        <label>可识读主流一维码、二维码，精度高，速度快。</label>
      </div>
      <div>
        <img :src="require('@/assets/pic/zts260/bg2icon2.png')" />
        <label>支持语音播报功能，内置非接读卡器。</label>
      </div>
    </div>
    <div id="z4">
      <div>高标准安全设计</div>
      <label>内置安全芯片，信息交互更安全</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZTS260',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['32位高性能安全CPU'],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['8MB RAM+8MB ROM'],pic: 'ram.png'},
          {label: _this.$t('lang.display'), desc: ['2.4英寸240×320LCD'], pic: 'speaker.png'},
          {label: '通讯', desc: ['WIFI / 4G / 4G+WIFI'], pic: 'comm.png'},
          {label: _this.$t('lang.keyboard'), desc: ['数字键×10','功能键×10',_this.$t('lang.powerbtn1')], pic: 'keyb.png'},
          {label: _this.$t('lang.scaner'), desc: [_this.$t('lang.spkofcode')], pic: 'scan.png'},
          {label: _this.$t('lang.port'), desc: ['Micro USB ×1'], pic: 'port.png'},
          {label: _this.$t('lang.bettery'), desc: ['锂电池3.7V/2000mAh'], pic: 'battery.png'},
          {label: _this.$t('lang.adapter'), desc: ['输入: AC 100~240V','输出: DC 5V/1A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['188mm×84mm×50.5mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zts260 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zts260/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.79rem;
  color: #4D4D4D;
}
#z1 div {
  margin-top: 3.59rem;
  font-size: .72rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .05rem;
  margin-bottom: .32rem;
  font-size: .6rem;
}
#z1 img {
  width: 3.03rem;
}
#z2 {
  height: 1.78rem;
  background: #A6A6A6;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 15.71rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zts260/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 10rem;
  color: #4D4D4D ;
}
#z3 h3 {
  font-size: .6rem;
  font-weight: bold;
  color: #FFFFFF;
  margin: 2.65rem 0 .59rem 0;
}
#z3 img {
  width: .5rem;
  margin: 0;
  display: inline-block;
}
#z3 div {
  width: 4.5rem;
  margin-bottom: .18rem;
}
#z3 label {
  color: #F4F4F4;
  width: 3.5rem;
  display: inline-block;
  vertical-align: top;
  margin-left: .24rem;
  font-size: .24rem;
  font-weight: 400;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zts260/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.44rem;
  color: #4D4D4D;
}
#z4 div {
  margin: 3.52rem 0 .27rem 0;
  font-size: .6rem;
  font-weight: bold;
}
#z4 label {
  display: block;
  font-size: .24rem;
  font-weight: 400;
}
</style>
